// API Configuration
export const DEFAULT_API_BASE_URL = 'http://localhost:3001/api';
export const DEFAULT_SERVER_BASE_URL = 'http://localhost:3001';
export const API_TIMEOUT = 900000; // 15 minutes for large imports

// HTTP Status Codes
export const HTTP_OK = 200;
export const HTTP_CREATED = 201;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_CONFLICT = 409;
export const HTTP_INTERNAL_SERVER_ERROR = 500;

// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const PAYMENTS_PAGE_SIZE = 20; // Tamaño estándar para paginación de pagos dentro de cada lote
export const USERS_PAGE_SIZE = 50;

// Timeouts and Intervals
export const DEFAULT_TOAST_DURATION = 4000;
export const COPY_FEEDBACK_DURATION = 2000;
export const SEARCH_DEBOUNCE_DELAY = 300;
export const STATS_REFRESH_INTERVAL = 30000;

// Storage Keys
export const AUTH_TOKEN_KEY = 'auth_token';
export const USER_DATA_KEY = 'user_data';

// Session Inactivity Timeout
// Must match backend SESSION_INACTIVITY_TIMEOUT_HOURS (8 hours)
export const SESSION_INACTIVITY_TIMEOUT_HOURS = 8;
export const SESSION_INACTIVITY_TIMEOUT_MS = SESSION_INACTIVITY_TIMEOUT_HOURS * 60 * 60 * 1000;
export const SESSION_INACTIVITY_WARNING_BEFORE_MS = 15 * 60 * 1000; // 15 min before expiry

// Example Values for Documentation
export const EXAMPLE_PAYMENT_ID = 1234;
export const EXAMPLE_TOTAL_PAYMENTS = 1250;
export const EXAMPLE_TOTAL_AMOUNT = 187500.75;
export const EXAMPLE_REQUEST_COUNT = 1247;

// File Upload
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_FILE_TYPES = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx'];

// UI Configuration
export const TABLE_ROWS_PER_PAGE = [10, 20, 50, 100];
export const DEBOUNCE_DELAY = 500;
export const DASHBOARD_BILLERS_PER_PAGE = 5;
export const USER_MANAGEMENT_LIMIT = 10;